export default __webpack_public_path__ + "static/MultipleAccidents-305c19fb24a7c25e45002c07dec45c19.svg";